import { FiChevronRight } from "react-icons/fi";
import {
  IoIosCheckmarkCircle,
  IoIosCheckmarkCircleOutline,
  IoIosCloseCircleOutline,
} from "react-icons/io";
import { IoChevronBack } from "react-icons/io5";
import { Link, NavLink } from "react-router-dom";
import Button from "./Button";

export const NavigationLink = ({
  title,
  className = "",
  children,
  ...rest
}) => (
  <NavLink
    className={({ isActive }) =>
      "font-semibold hover:text-sky-600 dark:hover:text-sky-700 " +
      (isActive
        ? "text-sky-600 dark:text-sky-700"
        : "text-gray-700 dark:text-gray-300") +
      " " +
      className
    }
    {...rest}
  >
    {title}
    {children}
  </NavLink>
);

export const ButtonWithArrow = ({
  className = "",
  show = false,
  children,
  ...rest
}) => {
  return (
    <button
      className={`cursor-pointer font-semibold flex items-center space-x-2 outline-none focus:outline-none relative max-w-full ${className}`}
      {...rest}
    >
      <div className="flex items-center space-x-2 max-w-full">{children}</div>
      <FiChevronRight
        className={`transform flex-shrink-0 transition-transform ${show ? "rotate-90" : "rotate-0"}`}
      />
    </button>
  );
};

export const ButtonX = ({ onClick, className = "2xl" }) => (
  <div
    className={`
         ${className}
         cursor-pointer
         animate-ease-2 text-red-400 hover:text-red-600 active:text-red-700`}
  >
    <IoIosCloseCircleOutline size={27} onClick={onClick} />
  </div>
);

export const Tag = ({
  title,
  leftView = null,
  rightView = null,
  selected = false,
  onClick,
  disabled = false,
  className = "",
}) => {
  const textColor =
    "text-gray-600 dark:text-gray-300 active:text-white active:dark:text-gray-200";
  const borderColor =
    "border-gray-100 dark:border-gray-700 active:border-sky-600 dark:active:border-sky-700 hover:border-sky-600";
  const bgColor =
    "bg-white dark:bg-gray-800 hover:bg-sky-100 active:bg-sky-700 dark:active:bg-sky-900";

  const selectedTextColor = "text-white text-gray-200 active:text-gray-600";
  const selectedBorderColor = "border-sky-600 dark:border-sky-700";
  const selectedBgColor =
    "bg-sky-600 hover:bg-sky-700 active:bg-white dark:bg-sky-900 ";

  return (
    <button
      disabled={disabled}
      type="button"
      onClick={onClick}
      className={`
            flex items-center
            border
            outline-none
            focus:outline-none whitespace-nowrap
            rounded-full px-4 py-1
            ${
              selected
                ? `
               ${selectedTextColor}
               ${selectedBorderColor}
               ${selectedBgColor}
               `
                : `
               ${textColor}
               ${borderColor}
               ${bgColor}
               `
            }
            ${disabled ? "cursor-not-allowed" : onClick ? "cursor-pointer" : "cursor-default"}
            disabled:opacity-70
            animate-ease-1
            ${className}
         `}
    >
      {leftView}
      <span>{title}</span>
      {rightView}
    </button>
  );
};

export const CheckBox = ({ size = 21, checked = false, onChange }) => {
  return (
    <div
      className="cursor-pointer"
      onClick={(e) => {
        e.preventDefault();
        if (onChange) {
          e.stopPropagation();
          onChange(!checked);
        }
      }}
    >
      {checked ? (
        <IoIosCheckmarkCircle
          size={size}
          className="text-green-500 hover:text-gray-500 active:text-gray-300"
        />
      ) : (
        <IoIosCheckmarkCircleOutline
          size={size}
          className="text-gray-300 hover:text-green-400 active:text-green-600"
        />
      )}
    </div>
  );
};

export const NavigationBar = ({
  className = "",
  title,
  backTo = "./..",
  onClickBack,
  rightButtons,
}) => {
  return (
    <header
      className={`flex justify-between items-center sticky top-0 backdrop-blur z-20 bg-gray-50 dark:bg-gray-800 bg-opacity-80 dark:bg-opacity-90 shadow-sm dark:shadow-gray-800 ${className}`}
    >
      <div className="flex-1">
        <div className="flex items-center">
          {backTo ? (
            <Link
              className="text-2xl w-12 h-12 flex items-center justify-center text-sky-600 hover:text-sky-700 active:text-sky-800 font-bold"
              to={backTo}
            >
              <IoChevronBack />
            </Link>
          ) : onClickBack ? (
            <Button className="mr-2" onClick={onClickBack}>
              <IoChevronBack size={21} />
            </Button>
          ) : null}
          <h4>{title}</h4>
        </div>
      </div>

      {rightButtons ? <div className="px-6">{rightButtons}</div> : null}
    </header>
  );
};
